import { DateTimeHelper } from '../../../utils/dateTimeHelper';
import { LegalIssueItem } from './legal-issue-item';
import { LoiFormAnswerType } from './loi-form-answer-type.enum';

const isLegalIssueConditionFulfilled = (
    conditionValues: string[],
    parentAnswer: string | null,
    answerType: LoiFormAnswerType
): boolean => {
    if (parentAnswer == null) {
        return false;
    }

    return conditionValues.some((conditionValue) => {
        if (answerType === LoiFormAnswerType.Number) {
            return parseFloat(conditionValue) === parseFloat(parentAnswer);
        }

        if (answerType === LoiFormAnswerType.Date) {
            return DateTimeHelper.areDatesEqualIgnoringTime(conditionValue, parentAnswer);
        }

        return conditionValue.toLowerCase() === parentAnswer.toLowerCase();
    });
};

export const isLegalIssueVisibleByLogic = (
    allItems: LegalIssueItem[],
    item: LegalIssueItem,
    visitedIds: Set<string> = new Set()
): boolean => {
    if (!item.isDisplayLogicEnabled) {
        return true;
    }

    if (item.customId && visitedIds.has(item.customId)) {
        return false;
    }

    if (item.customId) {
        visitedIds.add(item.customId);
    }

    const parent = allItems.find((i) => i.customId === item.logicParentCustomId);

    if (!parent) {
        return true;
    }

    const conditionMet = isLegalIssueConditionFulfilled(
        item.conditionValues,
        parent.value,
        parent.answerType
    );

    if (!conditionMet) {
        return false;
    }

    return isLegalIssueVisibleByLogic(allItems, parent, visitedIds);
};

export const wouldCreateCycle = (
    allItems: LegalIssueItem[],
    itemCustomId: string,
    candidateCustomId: string
): boolean => {
    const visited = new Set<string>();
    let current = allItems.find((i) => i.customId === candidateCustomId);

    while (current) {
        if (current.customId === itemCustomId) {
            return true;
        }
        if (!current.logicParentCustomId) {
            return false;
        }
        if (visited.has(current.customId!)) {
            return false;
        }
        visited.add(current.customId!);
        current = allItems.find((i) => i.customId === current!.logicParentCustomId);
    }

    return false;
};
